<template>
  <div
    v-if="tags.length"
    class="reviews-tags bg-gray-40 rounded-20 d-flex flex-column overflow-hidden"
    :class="isMobile ? 'py-4' : 'py-6'"
    data-qa="reviews_tags"
  >
    <div
      class="text-body-1 text--text mb-2"
      :class="isMobile ? 'px-4' : 'px-6'"
      data-qa="reviews_tags_title"
    >
      {{ tStatic('Пациенты упоминали в отзывах') }}
    </div>

    <CoreSwiper
      class="reviews-tags__swiper"
      slides-per-view="auto"
      :space-between="isMobile ? 8 : 16"
      :slides-offset-before="isMobile ? 16 : 24"
      :slides-offset-after="isMobile ? 16 : 24"
      :has-pagination="false"
      :has-navigation="!isMobile"
      :auto-height="false"
      free-mode
    >
      <template #slides="{ slideAttrs }">
        <div
          v-for="tag in tags"
          :key="tag.translit"
          v-bind="slideAttrs"
        >
          <button
            type="button"
            class="reviews-tags__card elevation-1 bg-gray-0 rounded-15 pa-4 d-flex flex-column ga-2"
            data-qa="reviews_tags_slide"
            @click="onTagClick(tag)"
          >
            <div
              class="text-subtitle-2 text--text text-no-wrap"
              data-qa="reviews_tags_name"
            >
              {{ tag.name }}
            </div>
            <div class="d-flex align-center">
              <div class="d-flex align-center pr-4">
                <span class="ui-icon-heart-active ui-icon-fz-big text-lpu-branding-color-primary flex-shrink-0" />
                <span
                  class="text-body-2 text--text ml-1"
                  data-qa="reviews_tags_count_liked"
                >
                  {{ tag.countLikedRates }}
                </span>
              </div>
              <div class="d-flex align-center">
                <span class="ui-icon-heart-broken ui-icon-fz-big bg-gray-80--text flex-shrink-0" />
                <span
                  class="text-body-2 text--text ml-1"
                  data-qa="reviews_tags_count_disliked"
                >
                  {{ tag.countDislikedRates }}
                </span>
              </div>
            </div>
          </button>
        </div>
      </template>
    </CoreSwiper>
  </div>
</template>

<script lang="ts" setup>
import useIsMobile from 'src/composables/useIsMobile'
import useYandexGoals from 'src/composables/useYandexGoals'
import CoreSwiper from 'src/core/CoreSwiper/CoreSwiper.vue'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'
import type { ReviewTag } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/types'

const props = defineProps<{
  tags: ReviewTag[]
  redirectPathname: string
}>()

const isMobile = useIsMobile()
const { sendYaGoal } = useYandexGoals()

function onTagClick(tag: ReviewTag) {
  if (typeof window === 'undefined' || !props.redirectPathname) {
    return
  }

  sendYaGoal('reviews_list_click_tag_lpu_redirect')

  const url = new URL(props.redirectPathname, window.location.origin)

  url.searchParams.set('tag', tag.translit)
  url.hash = 'tab-content'
  window.location.assign(url.href)
}
</script>

<style scoped lang="scss">
.reviews-tags {
  min-width: 0;

  &__swiper {
    min-width: 0;
    min-height: 100px;

    :deep(.swiper-container) {
      min-height: 100px;
      padding-top: 8px;
      padding-bottom: 8px;
    }

    :deep(.swiper-container--no-pagination) {
      padding-bottom: 8px;
    }

    :deep(.swiper-wrapper),
    :deep(.swiper-slide) {
      min-height: 84px;
    }

    &:not(.core-swiper--ready) :deep(.swiper-container) {
      height: 100px !important;
    }
  }

  &__card {
    height: 84px;
    border: 0;
    font: inherit;
    color: inherit;
    text-align: left;
    cursor: pointer;
  }
}
</style>
